
























































































































































/** @format */
import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// 下拉框封装组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { merchantSpacePool } from '@/api/discount-management/index';
import { queryMonthCardStop, quertMonthCardRefund, merchantSpacePoolGetPark } from '@/api/fixed-car-management';
import Utils from '@root/utils/common';
import { BUSINESS_LIST } from '../router-names';
import { LONG_RENTAL_CAR_RENEW, LONG_RENTAL_CAR_DETAIL } from '../../fixed-car-management/router-names';
import { BUSINESS_LIST_CAR_NEW } from '../router-names';

import moment from 'moment';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  name: 'ParkingPool',
  components: { ParkingLotSearch }
})
export default class ParkingPool extends Mixins(TableMixin, TableWidthMixin) {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  private filterParam: any = {
    parkIds: [], //选中的车场
    statusF: []
  };
  private tableLoading: boolean = false;
  tableData: any[] = [];
  headTitle: string = '';
  merchantId: string = '';
  returnAmount = false;
  confirmRefundLoading = false;
  refund = {
    payType: '01',
    refundPrice: '0',
    refundPriceErr: true,
    endDate: null,
    endDateErr: true
  };
  refundDetail = {
    cardId: '',
    endDate: null
  };
  needRefundMethod: boolean = true;
  private moment = moment;
  endDateTimes = '';
  startDateTimes = '';
  disabledDateT(current: any) {
    return (
      (current && current <= moment().startOf('day')) ||
      current > moment(this.refundDetail.endDate, 'YYYY-MM-DD') ||
      current > moment(this.endDateTimes, 'YYYY-MM-DD') ||
      current < moment(this.startDateTimes, 'YYYY-MM-DD')
      // .subtract(1, 'day')
    );
  }

  // 授权状态
  stateType = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.merchant_month_card_status);

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '商家管理',
        location: {
          name: BUSINESS_LIST
        }
      },
      {
        label: '车位池'
      }
    ];
  }

  //table列表
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        width: 180,
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '收费套餐',
        width: 180,
        dataIndex: 'packageName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '车位号',
        dataIndex: 'code',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '泊车数量',
        dataIndex: 'parkingNum',
        width: 140,
        customRender: (text: any) => {
          if (text !== 'null') {
            return `${text}个`;
          }
          return '--';
        }
      },
      {
        title: '授权区域',
        width: 160,
        dataIndex: 'area',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '授权期起',
        width: 160,
        dataIndex: 'startDate'
      },
      {
        title: '授权期止',
        width: 160,
        dataIndex: 'endDate'
      },
      {
        title: '授权状态',
        width: 140,
        dataIndex: 'statusString'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 280,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  //table初始化
  current = 1;
  pageSize = 10;
  async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkIds, statusF } = this.filterParam;
      const { status, code, msg, data } = await merchantSpacePool({
        parkIds: parkIds.join(','),
        status: statusF.join(','),
        merchantId: this.merchantId,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  //点击搜索
  searchTable() {
    this.current = 1;
    this.fetchTableData();
  }
  //清空table
  onTableFilterClear() {
    this.filterParam = {
      parkIds: [],
      statusF: []
    };
    this.searchTable();
  }
  // 去续费
  toRenew(item: any) {
    this.$router.push({
      name: LONG_RENTAL_CAR_RENEW,
      query: {
        cardId: item.cardId,
        useType: '02',
        status: item.status,
        mobile: this.$route.query.mobile,
        name: this.$route.query.name,
        merchantId: this.$route.query.merchantId,
        isPool: true
      }
    } as any);
  }

  //  停租
  private async queryMonthCardStopClick(cardId: any) {
    const load: any = this.$message.loading('正在停租');
    try {
      const { status, msg, date } = await queryMonthCardStop({ cardId });
      if (status === '9999') {
        this.$message.success('停租成功');
        this.fetchTableData();
      } else {
        this.$message.error('停租失败');
      }
    } catch (e) {
      console.log('queryMonthCardStop   接口错误');
    } finally {
      load();
    }
  }
  handleNumberChange(e: any) {
    this.refund.refundPrice = e.target.value.replace(/[^\d.]/g, '');
  }
  @Getter('dictionaries/newCardPaymentPayType')
  newCardPaymentPayType?: any;
  get traderecordPayMethodsList() {
    return Utils.toLabelVal(this.newCardPaymentPayType);
  }
  // 退费
  refundClick(item: any) {
    console.log(item);
    if (item.refundMethod && item.refundMethod === '00') {
      this.needRefundMethod = false;
    }
    this.endDateTimes = item.endDate;
    this.startDateTimes = item.startDate;
    this.returnAmount = true;
    const { cardId, endDate } = item;
    this.refundDetail = { cardId, endDate };
  }
  // 退费弹窗
  private async changeRefundOK() {
    this.confirmRefundLoading = true;
    try {
      let { cardId } = this.refundDetail;
      let { payType, refundPrice, endDate, refundPriceErr, endDateErr } = this.refund;
      if (!endDate) {
        this.refund.endDateErr = false;
      } else {
        this.refund.endDateErr = true;
      }
      if (!refundPrice) {
        this.refund.refundPriceErr = false;
      } else {
        this.refund.refundPriceErr = true;
      }
      if (!this.refund.refundPriceErr || !this.refund.endDateErr) {
        return false;
      }
      const { status, msg, data } = await quertMonthCardRefund({
        cardId,
        payType,
        refundPrice: Number(refundPrice).toFixed(2),
        endDate: moment(endDate).format('YYYY-MM-DD')
      });
      if (status === '9999') {
        //this.returnAmount = false
        this.changeCarCancel();
        this.$message.success(data);
        this.fetchTableData();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      if (e.msg) {
        this.$message.error(e.msg);
      }
    } finally {
      this.confirmRefundLoading = false;
    }
  }
  changeCar = false;
  // 退费弹窗关闭
  changeCarCancel() {
    this.refund = {
      payType: '01',
      refundPrice: '0',
      refundPriceErr: true,
      endDate: null,
      endDateErr: true
    };
    this.changeCar = false;
    this.returnAmount = false;
  }
  // 创建月卡
  toNewCard(isCreate: any) {
    this.$router.push({
      name: BUSINESS_LIST_CAR_NEW,
      query: {
        useType: '02',
        mobile: this.$route.query.mobile,
        name: this.$route.query.name,
        merchantId: this.$route.query.merchantId,
        isCreate: isCreate
      }
    });
  }
  //详情
  toRenewDetail(record: any, isDetail: any) {
    this.$router.push({
      name: LONG_RENTAL_CAR_DETAIL,
      query: {
        cardId: record.cardId,
        useType: '01',
        isDetail: isDetail,
        mobile: this.$route.query.mobile,
        name: this.$route.query.name,
        merchantId: this.$route.query.merchantId,
        isPool: true
      }
    } as any);
  }
  // 追加
  toAppendDetail(record: any) {
    this.$router.push({
      name: BUSINESS_LIST_CAR_NEW,
      query: {
        cardId: record.cardId,
        useType: '02',
        mobile: this.$route.query.mobile,
        name: this.$route.query.name,
        merchantId: this.$route.query.merchantId
      }
    });
  }
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    this.$router.push({
      name: BUSINESS_LIST
    });
  }
  created() {
    this.headTitle = this.$route.query.name as string;
    this.merchantId = this.$route.query.merchantId as string;
    this.fetchTableData();
    this.getParkingList();
  }
  activated() {
    this.headTitle = this.$route.query.name as string;
    this.merchantId = this.$route.query.merchantId as string;
    this.fetchTableData();
    this.getParkingList();
  }
  parkingList: any[] = [];
  async getParkingList() {
    try {
      const { status, data } = await merchantSpacePoolGetPark({ merchantId: this.merchantId });
      if (status === '9999') {
        this.parkingList = data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  private filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
